import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { MonitoredTrain } from '../../models/monitored-train';

@Component({
  selector: 'app-monitored-trains-tiles',
  template: require('./monitored-trains-tiles.component.html'),
  styles: [require('./monitored-trains-tiles.component.sass')],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MonitoredTrainsTilesComponent implements OnInit {

  viewMode: string = 'list';

  @Input() monitoredTrains: MonitoredTrain[];
  @Input() projectId: number;

  @Output() investigateTrain = new EventEmitter<MonitoredTrain>();

  
  constructor() { }

  ngOnInit(): void {
  }

  onInvestigateTrain = (train: MonitoredTrain) => {
    this.investigateTrain.emit(train);
  }

}
